import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #e1e7ee;
`;

export const Container = styled.div(
  props => `
    width: 1200px;
    margin: 0 auto;
    padding-top: ${props.pt || ''};
    padding-bottom: ${props.pb || ''};
  `
);

export const LeftWrap = styled.div`
  width: 285px;
  float: left;
`;

export const RightWrap = styled.div`
  width: 895px;
  float: right;
`;

export const DisableClickOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
  opacity: 0;
`;
